import {axiosApiCallWithToken} from "../axios/customInstance";


export const getPatients = async (
    medicalStaffId
) => {
    const url =
        "/medicalStaff/patient" +
        "/" +
        medicalStaffId;

    const response = await axiosApiCallWithToken.get(url);
    return response.data;

};

export const getAllPatients = async () => {
    const url = "/medicalStaff/patients"

    const response = await axiosApiCallWithToken.get(url);
    return response.data;

};


export const getConversationMessages = async (
    userId,
    medicalStaffId
) => {
    const url =
        "/medicalStaff/patient" +
        "/" +
        userId +
        "/" +
        medicalStaffId;

    const response = await axiosApiCallWithToken.get(url);
    return response.data;

};

export const postNewMessage = async (messagePayload) => {
    const url = "/medicalStaff/patient";

    try {
        await axiosApiCallWithToken.post(url, messagePayload);
    } catch (error) {
        console.log(error);
        throw error;
    }
};


export const getUsersFiscalCode = async () => {
    const url = "/usersInfo";

    try {
        const response = await axiosApiCallWithToken.get(url);
        return response.data
    } catch (error) {
        console.log(error);
        throw error;
    }
}


export const associatePatient = async (payload) => {
    const url = "/associatePatient";

    console.log("PAYLOAD", payload)

    try {
        await axiosApiCallWithToken.post(url, payload);
    } catch (error) {
        console.log(error);
        throw error;
    }
}